//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.DoslaPostaListPage.ts                </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class DoslaPostaListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GSeznamFilterBaseDto;

        onContentReady() {
            var that = this;
            PodDokSpisListBasePage.InitList(this);
            this.FrmFiltr = "dosla_posta";
            //this.specialActions.push(this.CreateActionVyjmoutZeSpisovny());
            //this.specialActions.push(this.CreateActionVlozitDoBaliku());

            //this.specialActions.push(SpiListBaseAC.CreateActionZmenitSpisovyZnak(this, false, true));

            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    // 01.03.2021 - TFeik
                    // Nahrazení obsolete parametrů.
                    filterViewMode: FilterViewMode.Simple,
                    //simpleMode: true,
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                })

            this.CreateGrid();
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateFilterForms() {
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); 
            filterForm
                .addField("gdatecombobox", {
                    name: "DatumField",
                    model: "model.Datum=value.date",
                    defaultInitialValue: "all",
                    daysRangeMax: this.DaysRangeMax,
                    contextMenu: {
                        daysRange: 50
                    },
                    userSettings: this.userSettings,
                });
            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GSeznamFilterBaseDto) {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.call<Wfl.Interface.DokSpisCiziListDto[]>("LoadData", { "model": filtr })
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view);
                })
                .always(function () { Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that); });
        }

        ReloadData() {
            this.LoadData(this.model);
        }

        CreateGrid()
        {
            var gf = Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(Gordic.Wfl.Globals.ListSupport.EleColumn());
            gf.addNumberColumn(Wfl.ListPrefabs.porCisloColumn());
            gf.addTextColumn(Wfl.ListPrefabs.ixpColumn());
            gf.addDateTimeColumn(Wfl.ListPrefabs.datPrijPodaniColumn(""));
            gf.addTextColumn(ListPrefabs.PodCisloColumn());
            gf.addTextColumn(Wfl.ListPrefabs.odesilatelColumn());
            gf.add(Wfl.ListPrefabs.vecColumn());
            gf.addTextColumn(Wfl.ListPrefabs.zpusobDoruceniColumn());
            gf.addTextColumn(Wfl.ListPrefabs.PredanoSuColumn());
            gf.addDateColumn(Wfl.ListPrefabs.datPredaniColumn());

            gf.addTextColumn(ListPrefabs.StavNaPodatelneColumn());
            //gf.addTextColumn(Wfl.ListPrefabs.Druchzach()); // zkusíme nedalat

            gf.addTextColumn(Wfl.ListPrefabs.znackaColumn(this.LabelZnacka));
            gf.addTextColumn(Wfl.ListPrefabs.typDokumentuTxtColumn());
            gf.addTextColumn(Wfl.ListPrefabs.predanoUzluColumn());
            gf.addTextColumn(Wfl.ListPrefabs.predanoOsobeColumn());    

            if (this.mainGrid) this.mainGrid.remove();
            this.mainGrid = Wfl.ListAC.DokSpisListBaseAC.GetGridDokSpis(this, gf);
            Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

    }
};
